import { createAction, props, union } from '@ngrx/store';
import { RfrMonStacksQueryI } from 'src/app/api/rfr-mon-stacks/rfr-mon-stacks.query.int';
import { RfrMonStackI } from 'src/app/api/rfr-mon-stacks/rfr-mon-stacks.result.int';

export const load = createAction('[RFR MON / Stacks] Get', props<{ query: RfrMonStacksQueryI }>());
export const received = createAction('[RFR MON / Stacks] Received', props<{ data: RfrMonStackI[] }>());
export const reset = createAction('[RFR MON / Stacks] Reset', props<Record<string, unknown>>());
export const error = createAction('[RFR MON / Stacks] Error', props<{ messageText: string }>());

const all = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof all;
